import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.fileUploadState;
export const fileUploadErrorsSelector = (state: RootState) => getState(state).errors;
export const fileUploadProgressSelector = (state: RootState) =>
  getState(state).filesProcessingInProgress;
